import type { FC } from 'react';
import React from 'react';
import cn from 'classnames';

import type { TContentProps } from './models';

export const Content: FC<TContentProps> = ({ Modal, children, className, flex, styles }) => (
    <Modal.Content className={cn(styles.modalV2Content, className)} flex={flex}>
        {children}
    </Modal.Content>
);
